export default __webpack_public_path__ + "static/assets/med_pill_rectangle_out_L0_solid_x_01_f.cc38f052.png";